export enum TestWindowFileSlug {
    FSA_ODI = 'fsa-odi'
}